// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3SU0a","productName":"Table_productName__1s8G_"};